import { SnackbarProvider } from "notistack";
import React from "react";
import DefaultNotistackContent from "./components/notistack/DefaultNotistackContent";
import SuccessNotistackContent from "./components/notistack/SuccessNotistackContent";
import { AuthProvider } from "./features/auth/providers/AuthProvider";
import { WaypointApolloProvider } from "./lib/apollo/ApolloProvider";
import { FirebaseCloudMessaging } from "./lib/firebase";
import { WaypointMaterialUIProvider } from "./lib/material-ui/WaypointMaterialUIProvider";
import ReactQueryProvider from "./lib/react-query/ReactQueryProvider";
import { WaypointStatsigProvider } from "./lib/statsig/WaypointStatsigProvider";

export const AppProviders = ({ children }) => {
	return (
		<AuthProvider>
			<FirebaseCloudMessaging />
			<WaypointStatsigProvider>
				<WaypointApolloProvider>
					<ReactQueryProvider>
						<WaypointMaterialUIProvider>
							<SnackbarProvider
								maxSnack={1}
								Components={{
									success: SuccessNotistackContent,
									error: DefaultNotistackContent,
									info: DefaultNotistackContent,
									warning: DefaultNotistackContent,
									default: DefaultNotistackContent,
								}}
							>
								{children}
							</SnackbarProvider>
						</WaypointMaterialUIProvider>
					</ReactQueryProvider>
				</WaypointApolloProvider>
			</WaypointStatsigProvider>
		</AuthProvider>
	);
};
